import React, { useState } from 'react';
import Header from './components/Header';
import Entries from './components/Entries';
import classdefs from './App.module.css';

function App() {
  //const [theState, setState] = useState(1);

  return (
    <main className={classdefs.core}>
      <Header />
      <Entries />
      <div className={classdefs.detail}>amusing.org has been busted for a while, but now I'm hoping to reinstate it by using it as an excuse to do a React tutorial for myself.</div>
    </main>
  );
}

export default App;
